"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthProvider = void 0;
var domofon_1 = require("./domofon");
var AuthProvider = /** @class */ (function (_super) {
    __extends(AuthProvider, _super);
    function AuthProvider(props) {
        var _a;
        var parentOrigin = new window.URLSearchParams(window.location.search).get('parent_origin');
        var origins = ((_a = new window.URLSearchParams(window.location.search).get('origins')) === null || _a === void 0 ? void 0 : _a.split(',')) || [];
        if (!parentOrigin || !window.parent) {
            throw new Error('?parent_origin required');
        }
        return _super.call(this, __assign({ source: {
                origins: origins,
            }, target: {
                origin: parentOrigin,
                window: window.parent,
            } }, props)) || this;
    }
    AuthProvider.prototype.ready = function () {
        var _this = this;
        this.subscribe('tutoria-auth-client:handshake', function (_, meta) {
            _this.sendMessage({ name: 'tutoria-auth-provider:handshake' }, meta === null || meta === void 0 ? void 0 : meta.correlationId);
        });
    };
    return AuthProvider;
}(domofon_1.Domofon));
exports.AuthProvider = AuthProvider;
//# sourceMappingURL=provider-side.js.map